// Open a Telegram Mini App link as a phone-sized window docked to the bottom-right corner, so the
// dApp page stays visible behind it instead of being replaced by a full browser tab. Reuses one
// named window, so repeat calls focus the same wallet window rather than spawning new ones.
export function openWalletWindow(url: string = 'about:blank'): Window | null {
  if (typeof window === 'undefined') return null;
  const availWidth = window.screen?.availWidth ?? 1280;
  const availHeight = window.screen?.availHeight ?? 800;
  const width = 390; // phone width
  const height = Math.min(820, availHeight - 40);
  const left = Math.max(0, availWidth - width - 16); // bottom-right, small margin
  const top = Math.max(0, availHeight - height - 16);
  const features = `popup=yes,width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`;
  try {
    return window.open(url, 'onewallet_tma', features);
  } catch {
    return null;
  }
}
